// CANCEL SUBSCRIPTION
export const CANCEL_SUBSCRIPTION = 'manage_subscription/CANCEL_SUBSCRIPTION';
export const SET_CANCEL_SUBSCRIPTION_WAITING =
  'manage_subscription/SET_CANCEL_SUBSCRIPTION_WAITING';
export const SET_CANCEL_SUBSCRIPTION_MESSAGE =
  'manage_subscription/SET_CANCEL_SUBSCRIPTION_MESSAGE';
export const SET_CANCEL_SUBSCRIPTION_SUCCESS =
  'manage_subscription/SET_CANCEL_SUBSCRIPTION_SUCCESS';

// REVERT CANCELLATION
export const REVERT_CANCELLATION = 'manage_subscription/REVERT_CANCELLATION';
export const SET_REVERT_CANCELLATION_WAITING =
  'manage_subscription/SET_REVERT_CANCELLATION_WAITING';
export const SET_REVERT_CANCELLATION_MESSAGE =
  'manage_subscription/SET_REVERT_CANCELLATION_MESSAGE';
export const SET_REVERT_CANCELLATION_SUCCESS =
  'manage_subscription/SET_REVERT_CANCELLATION_SUCCESS';

// SWITCH TO STRIPE SUBSCRIPTION
export const SWITCH_TO_STRIPE_SUBSCRIPTION =
  'manage_subscription/SWITCH_TO_STRIPE_SUBSCRIPTION ';
export const CANCEL_SCHEDULE_ON_SWITCH_IOS_STRIPE =
  'manage_subscription/CANCEL_SCHEDULE_ON_SWITCH_IOS_STRIPE';

// RENEW SUBSCRIPTION
export const RENEW_SUBSCRIPTION = 'manage_subscription/RENEW_SUBSCRIPTION';

// CHANGE SUBSCRIPTION
export const CHANGE_SUBSCRIPTION = 'manage_subscription/CHANGE_SUBSCRIPTION';

// UPGRADE SUBSCRIPTION
export const UPGRADE_SUBSCRIPTION = 'manage_subscription/UPGRADE_SUBSCRIPTION';

// ACTIVATE SUBSCRIPTION
export const ACTIVATE_SUBSCRIPTION =
  'manage_subscription/ACTIVATE_SUBSCRIPTION';
export const SET_SUBSCRIPTION_ACTIVATION_WAITING =
  'manage_subscription/SUBSCRIPTION_ACTIVATION_WAITING';
export const SET_SUBSCRIPTION_ACTIVATION_SUCCESS =
  'manage_subscription/SUBSCRIPTION_ACTIVATION_SUCCESS';
export const SET_SUBSCRIPTION_ACTIVATION_MESSAGE =
  'manage_subscription/SUBSCRIPTION_ACTIVATION_MESSAGE';

// UPDATE SUBSCRIPTION PLAN
export const UPDATE_SUBSCRIPTION_PLAN =
  'manage_subscription/UPDATE_SUBSCRIPTION_PLAN';
export const SET_UPDATE_SUBSCRIPTION_PLAN_WAITING =
  'manage_subscription/UPDATE_SUBSCRIPTION_PLAN_WAITING';
export const SET_UPDATE_SUBSCRIPTION_PLAN_SUCCESS =
  'manage_subscription/UPDATE_SUBSCRIPTION_PLAN_SUCCESS';
export const SET_UPDATE_SUBSCRIPTION_PLAN_MESSAGE =
  'manage_subscription/UPDATE_SUBSCRIPTION_PLAN_MESSAGE';
export const SET_REFUND_AMOUNT_MESSAGE =
  'manage_subscription/SET_REFUND_AMOUNT_MESSAGE';

// GENERAL
export const SET_SUBSCRIPTION_OPERATION_WAITING =
  'manage_subscription/SUBSCRIPTION_OPERATION_WAITING';
export const SET_SUBSCRIPTION_OPERATION_SUCCESS =
  'manage_subscription/SUBSCRIPTION_OPERATION_SUCCESS';
export const SET_SUBSCRIPTION_OPERATION_MESSAGE =
  'manage_subscription/SUBSCRIPTION_OPERATION_MESSAGE';
export const RESET_COMPONENT = 'manage_subscription/RESET_COMPONENT';
